import * as React from "react";
import { LearnMoreResources, TopicsContainer } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonViews";
import ExternalLink from "~/components/Navigation/ExternalLink/index";
export const ProjectRunbooksTopics = () => (<TopicsContainer>
        <LearnMoreResources>
            <div>
                <ExternalLink href="RunbookExamples">Runbook examples</ExternalLink>
            </div>
        </LearnMoreResources>
    </TopicsContainer>);
